// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"182":"4b5928d6","245":"cd121e51","444":"ecef4652"}[chunkId] + ".css";
};